/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrderDto as DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';

export interface CancelPurchaseOrder$Params {
  inventoryId: string;
  purchaseOrderId: string;
}

export function cancelPurchaseOrder(http: HttpClient, rootUrl: string, params: CancelPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
  const rb = new RequestBuilder(rootUrl, cancelPurchaseOrder.PATH, 'put');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('purchaseOrderId', params.purchaseOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>;
    })
  );
}

cancelPurchaseOrder.PATH = '/api/inventories/{inventoryId}/purchase-orders/{purchaseOrderId}/cancel';
